import React from 'react';
import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';

const MinusIcon = (props) => (
  <SvgIcon {...props}>
    <path d="M7 12H17" stroke={props.sx?.color || '#080F1D'} strokeWidth="2" strokeLinecap="round" />
  </SvgIcon>
);

MinusIcon.propTypes = {
  sx: PropTypes.object,
};

export default MinusIcon;
